import { configuredFetch, HttpMethod } from 'api';
import { UIFilter } from 'models';

export interface SortItem {
  id: string;
  label: string;
}

export interface APIResponse<T> {
  data: T;
  meta?: {
    returnedRecords: number;
    totalRecords: number;
    sortOptions?: SortItem[];
    filters?: UIFilter[];
    show_onboarding_banner?: boolean;
    total?: number;
    warning?: number;
    danger?: number;
  };
  links?: any;
  errors?: any;
}

// This function will be call anytime useQuery is used
type DefaultQueryFnParams = { queryKey: string[] };
export async function defaultQueryFn({ queryKey }: DefaultQueryFnParams) {
  const url = Array.isArray(queryKey) ? queryKey.join('/') : queryKey;
  return configuredFetch(url).then((res) => res.json());
}

export async function defaultMetaQueryFn(url: string) {
  return configuredFetch(url).then((res) => res.json());
}

export async function defaultMutationFn(
  url: string,
  method: HttpMethod,
  data?: any
) {
  return configuredFetch(url, {
    method,
    body: data ? JSON.stringify(data) : undefined,
  }).then((res) => res.json());
}

export async function defaultRawMutationFn(
  url: string,
  method: HttpMethod,
  data: any = {}
) {
  return configuredFetch(url, {
    method,
    body: data,
  }).then((res) => res.json());
}

export async function defaultTextPlainMutationFn(
  url: string,
  method: HttpMethod,
  data: any = {}
) {
  return configuredFetch(url, {
    method,
    body: data,
    headers: {
      'content-type': 'text/plain',
    },
  }).then((res) => res.json());
}
